import api from "services/api";

export const fetchListCertificationNames = async () => {
  const res = await api.get("/ListCertificationName");
  return res.data;
};
